import { useTranslation } from 'react-i18next'
import { Helmet } from 'react-helmet-async'
import { HeroSection } from '@/components/sections/HeroSection'
import { TextSection } from '@/components/sections/TextSection'
import { FeatureGrid } from '@/components/sections/FeatureGrid'
import { ImageTextSplit } from '@/components/sections/ImageTextSplit'
import { QuoteCTA } from '@/components/sections/QuoteCTA'
import { FleetSection } from '@/components/sections/FleetSection'

export default function Company() {
  const { t, i18n } = useTranslation('common')

  return (
    <>
      <Helmet>
        <title>{t('company.seo.title')}</title>
        <meta name="description" content={t('company.seo.description')} />
        <html lang={i18n.language} />
      </Helmet>

      <HeroSection
        imageSrc="/images/company-hero-azienda.jpg"
        title={t('company.hero.title')}
        subtitle={t('company.hero.subtitle')}
        slogan={t('company.hero.slogan')}
        imagePosition="center 20%"
        overlayClassName="bg-brand-dark/80"
        primaryCta={{ label: t('buttons.contactUs'), to: 'contacts' }}
        secondaryCta={{ label: t('nav.services'), to: 'services' }}
      />

      <FleetSection />

      <TextSection
        heading={t('company.intro.heading')}
        body={t('company.intro.body')}
        align="center"
      />

      <ImageTextSplit
        imageSrc="/images/vision-mechanics.jpg"
        imageAlt={t('company.vision.imageAlt')}
        heading={t('company.vision.heading')}
        body={t('company.vision.body')}
        imagePosition="right"
        variant="dark"
      />

      <ImageTextSplit
        imageSrc="/images/method-office.jpg"
        imageAlt={t('company.mission.imageAlt')}
        heading={t('company.mission.heading')}
        body={t('company.mission.body')}
        imagePosition="left"
      />

      <QuoteCTA />

      <FeatureGrid
        heading={t('company.values.heading')}
        items={[
          {
            icon: 'brain',
            title: t('company.values.rationality.title'),
            description: t('company.values.rationality.description'),
          },
          {
            icon: 'flame',
            title: t('company.values.passion.title'),
            description: t('company.values.passion.description'),
          },
          {
            icon: 'target',
            title: t('company.values.precision.title'),
            description: t('company.values.precision.description'),
          },
          {
            icon: 'search',
            title: t('company.values.curiosity.title'),
            description: t('company.values.curiosity.description'),
          },
        ]}
      />
    </>
  )
}